// in DD/MM/YYYY format: 26/11/2025
const dateInDDMMYYYY = '26/11/2025';

export const bannerUpdateTimestamp = new Date(dateInDDMMYYYY.split('/').reverse().join('-')).getTime();
